import { render, staticRenderFns } from "./Customer-home.vue?vue&type=template&id=484a7179"
import script from "./Customer-home.vue?vue&type=script&lang=js"
export * from "./Customer-home.vue?vue&type=script&lang=js"
import style0 from "./Customer-home.vue?vue&type=style&index=0&id=484a7179&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports